var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdvertisingMegaphone = function SvgAdvertisingMegaphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13206 12.8L3.58006 11.625L2.53406 8.881C2.45896 8.68308 2.45371 8.46544 2.51918 8.26413C2.58464 8.06281 2.7169 7.88989 2.89406 7.774L5.35206 6.169L6.11906 3.335C6.17447 3.13062 6.29812 2.95134 6.46947 2.82692C6.64082 2.7025 6.84956 2.64043 7.06106 2.651L9.99306 2.8L12.2791 0.955001C12.4441 0.821964 12.6496 0.749413 12.8616 0.749413C13.0735 0.749413 13.2791 0.821964 13.4441 0.955001L15.7301 2.8L18.6621 2.654C18.8736 2.64343 19.0823 2.7055 19.2536 2.82992C19.425 2.95434 19.5486 3.13362 19.6041 3.338L20.3711 6.172L22.8291 7.777C23.0064 7.89276 23.1387 8.06568 23.2042 8.26704C23.2697 8.4684 23.2643 8.6861 23.1891 8.884L22.1441 11.628L23.1891 14.371C23.2644 14.5691 23.2698 14.7869 23.2043 14.9884C23.1388 15.19 23.0064 15.3631 22.8291 15.479L20.3711 17.079L19.6001 19.914C19.545 20.1187 19.4215 20.2983 19.2501 20.4229C19.0787 20.5476 18.8697 20.6097 18.6581 20.599L15.7261 20.453L13.4401 22.294",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 19.769L2.406 22.378",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90796 8.147L16.202 18.063",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8711 17.541L2.07505 21.857L1.08105 20.291L10.2391 8.66901L15.8711 17.541Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05591 20.924L5.93191 22.27C6.07675 22.5075 6.2686 22.7128 6.49568 22.8734C6.72276 23.0341 6.98028 23.1466 7.25241 23.2041C7.52455 23.2616 7.80557 23.2628 8.07822 23.2078C8.35087 23.1528 8.60939 23.0426 8.83791 22.884C9.30509 22.5478 9.6261 22.0457 9.73522 21.4806C9.84434 20.9155 9.73333 20.33 9.42491 19.844L9.26191 19.608",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAdvertisingMegaphone;